import { render } from "./LogoSection.vue?vue&type=template&id=51a63994"
import script from "./LogoSection.vue?vue&type=script&lang=js"
export * from "./LogoSection.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__